import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import "../ui/modal/recipeCategories.ts";
import * as Storage from "../lib/Storage.ts";
import {recipeSyncCache,recipeCategoriesSyncCache} from "../mealplanner/mealplannerApi.ts"
import * as actionMenu from "./action-menu-registry.ts"
import {easyScorer, applyScorer } from "./searchController.ts";

import MAINTPL from "../mealplanner/recipeListWidget.mustache";
import TPL_LIST from "../mealplanner/recipeList.mustache";
import Icons from "../svg/Icons.ts";

var
  theNode: HTMLElement | null,
  view: string,
  cat: string | undefined,
  searchText = '';

amplify.subscribe("recipeNeedRefresh",function(){
  searchText  = '';
});

function filter(recipe){
  if(cat===undefined) return true;
  return recipe.recipeCategoryIdList.indexOf(cat)!==-1;
}
actionMenu.register({
  recipeFilter(){
    var buttons = [{onclick:'recipefilter',emoji:'🥘',i18nkey:'mp.allrecipe',selected:cat===undefined, fillMenu:true}];
    recipeCategoriesSyncCache.datas.forEach(category=>{
      var button = {onclick:'recipefilter|'+category.metaId,title:category.computedName(), fillMenu:true}
      if(category.emoji){
        button.emoji = category.emoji
      }else{
        button.svg = category.icon
      }
      button.selected = (category.metaId===cat)

      buttons.push(button)
    })
    buttons.push({onclick:FwDatas.getPermission("recipecatlist"),svg:Icons.ic_more_horizontal,i18nkey:'mp.categoriesMore'})
    return {menu:buttons}
  },
  recipeListMenu(){
    return {menu:[
      {onclick:'recipecatlist',svg:Icons.ic_tag,i18nkey:'mp.categoriesmanage'},
      Storage.localGet('mpshowhiddenrecipe')?{onclick:'mphidehiddenrecipe',svg:Icons.ic_eye_off,i18nkey:'mp.hidehiddenrecipe'}:{onclick:'mpshowhiddenrecipe',svg:Icons.ic_eye,i18nkey:'mp.showhiddenrecipe'}
    ]}
  }
})
Html.registerDom({
  recipefilter(categoryId: string){
    searchText = '';
    cat = undefined;
    if (theNode) {
      const searchInput = theNode.querySelector("input[name='search']") as HTMLInputElement;
      if (searchInput) {
        searchInput.value = searchText;
      }
    }

    cat = categoryId;
    displayRecipes()
  },
  mpshowhiddenrecipe(){
    Storage.localSet("mpshowhiddenrecipe","true")
    display()
  },
  mphidehiddenrecipe(){
    Storage.localRemove("mpshowhiddenrecipe")
    display()
  }

})

function initDom(node: HTMLElement){
  theNode = node;
  amplify.subscribe("recipeRefreshed",onrefresh);
  amplify.publish("recipeNeedRefresh");
}

function destroyDom(node: HTMLElement){
  theNode = null;
  amplify.unsubscribe("recipeRefreshed",onrefresh);
}

var recipeList,nodedItems;
function onrefresh(freshRecipe,freshDish,freshRecipeCategories){
  recipeList = freshRecipe;
  recipeList.sort(recipeComparator);
  display()
  displayRecipes();
}

function filterIsRecipe(recipe: any): boolean {
  //theNode expandable means in the meal suggestions
  const isSuggestionWidget = theNode?.dataset.expandable === 'true';

  if(isSuggestionWidget){
    return recipe.isMealSuggestion;
  }else{
    if(!recipe.isRecipe) return false;
    if(Storage.localGet("mpshowhiddenrecipe")) return true;
    return recipe.hasDetails;
  }
}

function recipeComparator(a,b){
  let delta = a.sortingIndex-b.sortingIndex;
  if(delta!==0){
    return delta;
  }
  return a.name.localeCompare(b.name);
}

const recipeScorer = easyScorer({name:10,ingredients:5});

function displayRecipes(){
  if (!theNode) return;

  var filtered = recipeList.filter((recipe: any)=>filterIsRecipe(recipe)).filter(filter);
  var nodedItems = applyScorer(filtered,recipeScorer,searchText)

  const recipeListContainer = theNode.querySelector('.mp-recipe-list') as HTMLElement;
  if (recipeListContainer) {
    Html.setHtml(recipeListContainer, TPL_LIST, {
      recipeListFiltered:nodedItems,
      recipeList
    });
  }

  var
    found = nodedItems.length>0,
    showEmptyAdd = (!found && (view!=='external') && searchText.length>0),
    showEmpty = !found && !showEmptyAdd;

  const noMatchEl = document.querySelector('.mp-nomatch') as HTMLElement;
  if (noMatchEl) {
    noMatchEl.style.display = showEmptyAdd ? '' : 'none';
    const searchedEl = noMatchEl.querySelector('.mp-searched') as HTMLElement;
    if (searchedEl) {
      searchedEl.innerHTML = i18n.get('mp.quickadd',searchText);
      searchedEl.setAttribute('data-fw-onclick', 'recipepickadd|'+searchText);
    }
  }

  const noItemEl = document.querySelector('.mp-noitem') as HTMLElement;
  if (noItemEl) {
    noItemEl.style.display = showEmpty ? '' : 'none';
    const searchedEl = noItemEl.querySelector('.mp-searched') as HTMLElement;
    if (searchedEl) {
      searchedEl.innerHTML = i18n.get('mp.noitem');
    }
  }
}

function display(){
  if (!theNode) return;

  const viewexternal = view === 'external';
  theNode.dataset.viewexternal = String(viewexternal);

  const data = {
    ...theNode.dataset,
    viewexternal,
    search: !viewexternal,
    quickadd: theNode.dataset.quickadd === 'true' && !viewexternal
  };

  Html.setHtml(theNode, MAINTPL, data);

  let timeout: number;
  const searchInput = theNode.querySelector("input[name='search']") as HTMLInputElement;
  if (searchInput) {
    searchInput.addEventListener("input", function(){
      const nodeInput = this;
      clearTimeout(timeout);
      timeout = setTimeout(function(){
        searchText = nodeInput.value;
        displayRecipes();
      }, 200);
    });

    searchInput.addEventListener("click", function(){
      this.focus();
    });

    searchInput.value = searchText;
  }

  if(recipeList){displayRecipes()}
}

Html.registerWidget('widget/recipeList',{initDom, destroyDom})

export{initDom, destroyDom}